import { Client } from '@umanforge/common';
import { PostClient } from '../interfaces/api_client.interfaces';

export const DEFAULT_POST_CLIENT: PostClient = { name: '', users: [] };
export const getCreateClient: ( t: ( str: string ) => string  ) => Client = t => {
  return { ...DEFAULT_POST_CLIENT, id: 'new_client', name: t( 'Create new client' ), isAdmin: undefined, sites: undefined };
};